import Title from "antd/es/typography/Title"
import Structure from "../Structure"
import { Breadcrumb, Button, Card, Col, Divider, Form, Input, Layout, Row, Select, Tag, Upload, message } from "antd"
import { CameraOutlined, HomeOutlined, LoadingOutlined, PlusOutlined, SaveOutlined, UserOutlined } from "@ant-design/icons"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { limpiarStringLetrasNumeros, limpiarStringNumeros, siEsRequeridoEnEsquema, validateEmail } from "../../lib/helpers/helpers"
import { config_s3, urlapi } from "../../lib/backend/data"
import { cerrarSesion } from "../../redux/actions/sesion"
import { rutas } from "../../lib/routes/routes"
import S3FileUpload from 'react-s3';
import SelectorColor from "./selectores/color"
import { obtenerUnidadesMedidaPorTipoPais } from "../../lib/helpers/hepler_main"
import CamposObligatoriosLeyenda from "../../subComponents/general/formularios/campos_obligatorios"
import SelectorGeneral from "../General/selector"
import { calcularVolumen } from "../../lib/helpers/main"

const CrearEquipo = (props) => {
    const [ loading, setLoading ] = useState(false)
    const [ showPassword, setShowPassword ] = useState(false)
    const [ loadingImagen, setLoadingImagen ] = useState(false)
    const pais = useSelector(state => state.pais)
    const idioma = useSelector(state => state.idioma)
    const session = useSelector(state => state.miusuario)
    const [messageApi, contextHolder] = message.useMessage();
    const [ usuario, setUsuario ] = useState({})
    const dispatch = useDispatch()
    const unidades_medida               = obtenerUnidadesMedidaPorTipoPais("longitud", pais).map(e => e)
    const unidades_medida_peso          = obtenerUnidadesMedidaPorTipoPais("peso", pais).map(e => e)
    const unidades_medida_volumen       = obtenerUnidadesMedidaPorTipoPais("volumen", pais).map(e => e)
    const [ condicion_sub_categoria, setCondicionSubCategoria ] = useState({ tipo: "equipo" })
    const module = 'equipos'

    const requeridos = [
        { value: 'patente', label: 'Patente' },
      ];

    const handleChangeVehiculoCustom = (e,name) => {
        usuario[name] = e._id
        if(name === "id_tipo") usuario.tipo = e.tipo
        if(name === "marca") usuario.modelo = ""
        console.log(usuario)
        return setUsuario({...{}, ...usuario})
    }

    const seleccionarConductor = (data) => {
            usuario.id_usuario = data._id
            console.log(usuario)
        return setUsuario({...{}, ...usuario})
    }

    const handleChangeSelect = (e,name) => {
        console.log(e)
        usuario[name] = e
        return setUsuario({...{}, ...usuario})
    }


    const handleChangeUsuario = (e) => {
        const { name, value } = e.target
        return setUsuario(prev => {
            let actual = {...prev}
            if(name === "rut"){
                actual[name] = limpiarStringLetrasNumeros(value)
            } else if(name === "phone"){
                actual[name] = limpiarStringNumeros(value)
            } else {
                actual[name] = value
            }
            actual.volumen = calcularVolumen(actual).volumen
            return {...{}, ...actual}
        })
    }

    const uploadButton = (
        <div>
          {loadingImagen ? <LoadingOutlined /> : <PlusOutlined />}
          <div
            style={{
              marginTop: 8,
            }}
          >
            Subir foto
          </div>
        </div>
      );

    const handleChangeUsuarioSelect = (name, value) => {
        usuario[name] = value
        return setUsuario(usuario)
    }

    const crearConductorNuevo = async () => {
        
        let faltantes = []
        requeridos.map(campo => {
            if(!usuario[campo.value]) faltantes.push(campo.label)
            return true
        })
        if(faltantes.length > 0) return messageApi.error(`Faltan campos: ${faltantes.join(', ')}`)  
        usuario.autorizado = "si"

        setLoading(true)
        const url = `${urlapi}/${module}`
        return fetch(url, {
            method: "POST",
            body: JSON.stringify(usuario),
            headers: {
                'Content-type': "application/json",
                'Authorization': `Bearer: ${session.tokenSession}`,
                'country': pais,
                'lang': idioma
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(async res => {
            if(!res){
                messageApi.error("Sin datos obtenidos")
            } else if(res.errorMessage){
                messageApi.error(res.errorMessage)
            } else if(res._id){
                messageApi.success("Creado exitosamente")
                return setTimeout(() => {
                    return window.location = `${rutas.equipment.slug}/${res._id}`
                }, 1000);
            }
            return setLoading(false)
        })
        .catch(error => {
            messageApi.error("No se pudo efectuar la operación")
            return setLoading(false)
        })
    }

    

    const handleChangeArchivo = async (e) => {

        const archivo = e.file.originFileObj
        setLoadingImagen(true)
        return S3FileUpload.uploadFile(archivo, config_s3)
        .then( async data => {
            console.log(data)
        if(!data.location) {
            messageApi.error('No pudimos cargar tu imagen')
            return setLoadingImagen(false)
        }

        usuario.imagen_perfil = data.location
        setUsuario({...{}, ...usuario})
        return setLoadingImagen(false)

        })
        .catch(err => {
            console.log(err)
            setLoadingImagen(false)
            return messageApi.error('No pudimos cargar tu imagen')
        })
    }

    const handleChangeCat = (e) => {
        setUsuario(prev => {
            let actual = {...prev}
            actual.id_categoria = e._id
            actual.id_sub_categoria = ''
            return { ...{}, ...actual}
        
        })
        setCondicionSubCategoria(prev => ({...prev, id_categoria: e._id }))
    }
    
    const handleChangeCustom = (e, name) => {
        setUsuario(prev => {
            let actual = {...prev}
            actual[name] = e?._id
            return { ...{}, ...actual}
        })
    }

    const handleChangeSubCat = (e) => {
        
        setUsuario(prev => {
            let actual = {...prev}
            actual.id_sub_categoria = e._id
            return { ...{}, ...actual}
        })
    }

    const render = () => {
        const calculo_volumen = calcularVolumen(usuario, usuario.unidad_medida )

        return <div>
            <Card className="mb-3">
            <Breadcrumb
                items={[
                {
                    href: rutas.dashboard.slug,
                    title: <HomeOutlined />,
                },
                {
                    href: rutas.equipment.slug,
                    title: <span>Equipos</span>,
                },
                {
                    title: 'Crear equipo',
                },
                ]}
            />
            <Title className="mb-2 mt-0">Crear equipo</Title>
            </Card>
            <Layout style={{ padding: 20 }}>
            <Row gutter={20}>
                <Col md={24}>
                        <Card size="small">
                    {/* <ModalSeleccionVehiculos onSelect={data => seleccionarConductor(data)} /> */}
                    {/* <Divider /> */}
            <CamposObligatoriosLeyenda />
            <Form layout="vertical">
            <Row gutter={10}>
                <Col md={6} xs={24}>
                    <Form.Item label="Título" required={siEsRequeridoEnEsquema('titulo',requeridos)} >
                    <Input mb={3} name="titulo" onChange={handleChangeUsuario} />
                    </Form.Item>
                </Col>
                <Col md={6} xs={24}>
                    <Form.Item label="Patente" required={siEsRequeridoEnEsquema('patente',requeridos)} >
                    <Input mb={3} name="patente" onChange={handleChangeUsuario} />
                    </Form.Item>
                </Col>
                <Col md={6} xs={24}>
                    <Form.Item label="Año" required={siEsRequeridoEnEsquema('ano',requeridos)} >
                    <Input mb={3} variant="filled" type="number" name="ano" onChange={handleChangeUsuario} />
                    </Form.Item>
                </Col>
                {/* <Col md={8} xs={24}>
                    <Form.Item label="Marca" required={siEsRequeridoEnEsquema('marca',requeridos)} >
                        <SelectorMarcas onChange={(e) => handleChangeVehiculoCustom(e,"marca")} />
                    </Form.Item>
                </Col>
                <Col md={8} xs={24}>
                    <Form.Item label="Modelo" required={siEsRequeridoEnEsquema('modelo',requeridos)} >
                        <SelectorModelo filterBy={usuario.marca} value={usuario.modelo} filterByKey="id_marca" onChange={(e) => handleChangeVehiculoCustom(e,"modelo")} />
                    </Form.Item>
                </Col>
                
                <Col md={8} xs={24}>
                    <Form.Item label="Tipo " required={siEsRequeridoEnEsquema('id_tipo',requeridos)} >
                        <SelectorTipo onChange={(e) => handleChangeVehiculoCustom(e,"id_tipo")} />
                    </Form.Item>
                </Col>
                <Col md={8} xs={24}>
                    <Form.Item label="Tipo de motor" required={siEsRequeridoEnEsquema('tipo_motor',requeridos)} >
                        <SelectorTipoMotor onChange={(e) => handleChangeVehiculoCustom(e,"tipo_motor")} />
                    </Form.Item>
                </Col> */}
                <Col md={6} xs={24}>
                    <Form.Item label="Color" required={siEsRequeridoEnEsquema('color',requeridos)} >
                        <SelectorColor onChange={(e) => handleChangeVehiculoCustom(e,"color")} />
                    </Form.Item>
                </Col>
                <Col md={6} xs={24}>
                    <Form.Item label="Ejes" required={siEsRequeridoEnEsquema('ejes',requeridos)} >
                    <Input mb={3} type="number" variant="filled" name="ejes" onChange={handleChangeUsuario} />
                    </Form.Item>
                </Col>
                <Col md={6} xs={24}>
                    <Form.Item label="Unidad de medida de peso" required={siEsRequeridoEnEsquema('unidad_medida_peso',requeridos)} >
                        <Select options={unidades_medida_peso.map(e => ({ value: e.code, label: e.unit }))} onChange={(e) => handleChangeSelect(e,"unidad_medida_peso")} />
                    </Form.Item>
                </Col>
                <Col md={6} xs={24}>
                    <Form.Item label="Peso del equipo" required={siEsRequeridoEnEsquema('peso_equipo',requeridos)} >
                    <Input mb={3} addonBefore={usuario.unidad_medida_peso} type="number" variant="filled" name="peso_equipo" onChange={handleChangeUsuario} />
                    </Form.Item>
                </Col>
                <Col md={6} xs={24}>
                    <Form.Item label="Número de chasis" required={siEsRequeridoEnEsquema('chasis',requeridos)} >
                    <Input mb={3} variant="filled" name="chasis" onChange={handleChangeUsuario} />
                    </Form.Item>
                </Col>
                <Col md={6} xs={24}>
                    <SelectorGeneral module="categorias" titulo="Categoría" condicion_default={{ tipo: "equipo" }} onChange={handleChangeCat} />
                </Col>
                <Col md={6} xs={24}>
                    <SelectorGeneral module="sub-categorias" value={usuario.id_sub_categoria} titulo="Sub Categoría" condicion_default={condicion_sub_categoria} onChange={handleChangeSubCat} />
                </Col>
                <Col md={6} xs={24}>
                    
                </Col>
                <Col md={6} xs={24}>
                    <SelectorGeneral module="categorias" titulo="Marca" condicion_default={{ tipo: "marca-equipo" }} onChange={(data) => handleChangeCustom(data, "id_marca")} />
                </Col>
                <Col md={6} xs={24}>
                    <SelectorGeneral module="categorias" titulo="Modelo" condicion_default={{ tipo: "modelo-equipo" }} onChange={(data) => handleChangeCustom(data, "id_modelo")} />
                </Col>
                <Col md={24} xs={24}>
                    <Title level={4}>Medidas del equipo</Title>
                    <Form.Item label="Unidad de medida de longitud" required={siEsRequeridoEnEsquema('unidad_medida',requeridos)} >
                        <Select options={unidades_medida.map(e => ({ value: e.code, label: e.unit }))} onChange={(e) => handleChangeSelect(e,"unidad_medida")} />
                    </Form.Item>
                </Col>
                <Col md={8} xs={24}>
                    <Form.Item label="Ancho" required={siEsRequeridoEnEsquema('medida_ancho',requeridos)} >
                    <Input addonBefore={usuario.unidad_medida} mb={3} variant="filled" type="number" name="medida_ancho" onChange={handleChangeUsuario} />
                    </Form.Item>
                </Col>
                <Col md={8} xs={24}>
                    <Form.Item label="Alto" required={siEsRequeridoEnEsquema('medida_alto',requeridos)} >
                    <Input addonBefore={usuario.unidad_medida} mb={3} variant="filled" type="number" name="medida_alto" onChange={handleChangeUsuario} />
                    </Form.Item>
                </Col>
                <Col md={8} xs={24}>
                    <Form.Item label="Largo" required={siEsRequeridoEnEsquema('medida_largo',requeridos)} >
                    <Input addonBefore={usuario.unidad_medida} mb={3} variant="filled" type="number" name="medida_largo" onChange={handleChangeUsuario} />
                    </Form.Item>
                </Col>
                <Col md={24} xs={24}>
                    <Title level={4}>Capacidad de carga</Title>
                </Col>
                <Col md={8} xs={24}>
                    <Form.Item label="Pallets" required={siEsRequeridoEnEsquema('pallets',requeridos)} >
                    <Input mb={3} variant="filled" type="number" name="pallets" onChange={handleChangeUsuario} />
                    </Form.Item>
                </Col>
                <Col md={8} xs={24}>
                    <Form.Item label="Ancho" required={siEsRequeridoEnEsquema('ancho',requeridos)} >
                    <Input addonBefore={usuario.unidad_medida} mb={3} variant="filled" type="number" name="ancho" onChange={handleChangeUsuario} />
                    </Form.Item>
                </Col>
                <Col md={8} xs={24}>
                    <Form.Item label="Alto" required={siEsRequeridoEnEsquema('alto',requeridos)} >
                    <Input addonBefore={usuario.unidad_medida} mb={3} variant="filled" type="number" name="alto" onChange={handleChangeUsuario} />
                    </Form.Item>
                </Col>
                <Col md={8} xs={24}>
                    <Form.Item label="Largo" required={siEsRequeridoEnEsquema('largo',requeridos)} >
                    <Input addonBefore={usuario.unidad_medida} mb={3} variant="filled" type="number" name="largo" onChange={handleChangeUsuario} />
                    </Form.Item>
                </Col>
                <Col md={6} xs={24}>
                    <Form.Item label="Capacidad de peso" required={siEsRequeridoEnEsquema('peso',requeridos)} >
                    <Input mb={3} addonBefore={usuario.unidad_medida_peso} variant="filled" type="number" name="peso" onChange={handleChangeUsuario} />
                    </Form.Item>
                </Col>
                <Col md={24} xs={24}>
                    <Title className="mt-0 mb-0" level={4}>Volumen de carga</Title>
                    <Title className="mt-0 mb-3 " level={4}>{calculo_volumen.volumen.toFixed(2)} <Tag>{calculo_volumen.unidadVolumen}</Tag> </Title>
                </Col>
                {/* <Col md={6} xs={24}>
                    <Form.Item label="Volumen total" required={siEsRequeridoEnEsquema('peso',requeridos)} >
                        <Title level={3} className="mb-0 mt-0">{usuario.volumen} m3</Title>
                    </Form.Item>
                </Col> */}
                {/* <Col md={6} xs={24}>
                    <Form.Item label="Unidad de medida de volumen" required={siEsRequeridoEnEsquema('unidad_medida_volumen',requeridos)} >
                        <Select options={unidades_medida_volumen.map(e => ({ value: e.code, label: e.unit }))} onChange={(e) => handleChangeSelect(e,"unidad_medida_volumen")} />
                    </Form.Item>
                </Col>
                <Col md={6} xs={24}>
                    <Form.Item label="Volumen de carga" required={siEsRequeridoEnEsquema('volumen',requeridos)} >
                    <Input mb={3} addonBefore={usuario.unidad_medida_volumen} variant="filled" type="number" name="volumen" onChange={handleChangeUsuario} />
                    </Form.Item>
                </Col> */}
                
            </Row>     
               
            <Button type="primary" loading={loading} style={{ width: "100%" }} mt={3} colorScheme="green" onClick={() => crearConductorNuevo()} ><SaveOutlined /> CREAR</Button>
            </Form>
            </Card>

                </Col>

            </Row>
            </Layout>
            {contextHolder}
        </div>
    }
    
    return <Structure component={render()} />
}

export default CrearEquipo